module.exports = __webpack_public_path__ + "static/media/t-image2.cf170d43.jpg";